/**
 * Whitelabel constants and enums.
 */

export enum PhoneNumberSettingEnum {
  NOT_NEEDED = 'NOT_NEEDED',
  REQUIRED = 'REQUIRED',
  OPTIONAL = 'OPTIONAL',
}

export const PHONE_NUMBER_SETTING_OPTIONS = [
  {
    id: PhoneNumberSettingEnum.NOT_NEEDED,
    text: 'Hide',
  },
  {
    id: PhoneNumberSettingEnum.REQUIRED,
    text: 'Show as required',
  },
  {
    id: PhoneNumberSettingEnum.OPTIONAL,
    text: 'Show as optional',
  },
];

export enum SwireLocationOptionsEnum {
  HONG_KONG_SAR = 'hong-kong-sar',
  OTHER = 'other',
}

export enum SWIRE_NOTIFICATION_TEXT_KEYS {
  TAIKOO_PLACE = 'mobile.profile.workplaceSettings.notificationText.taikooplace',
  PACIFIC_PLACE_OFFICE = 'mobile.profile.workplaceSettings.notificationText.pacificplaceoffices',
}

export enum SwireAppEnum {
  TAIKOO_PLACE = 'app.taikooplace.com',
  TAIKOO_PLACE_INSTANCE = 'taikooplace',
  PACIFIC_PLACE_OFFICE = 'app.pacificplaceoffices.com',
  PACIFIC_PLACE_OFFICE_INSTANCE = 'pacificplaceoffices',
}

export const SWIRE_APP_EN_PRIVACY_POLICY_URL =
  'https://www.swireproperties.com/en/privacy-policy';

export const SWIRE_APP_ZH_HK_PRIVACY_POLICY_URL =
  'https://www.swireproperties.com/zh-hk/privacy-policy';

export const SWIRE_APP_EN_TAIKOO_PLACE_TERMS_AND_CONDITIONS_URL =
  'https://www.taikooplace.com/en/taikooplaceapp-termsconditions';

export const SWIRE_APP_ZH_HK_TAIKOO_PLACE_TERMS_AND_CONDITIONS_URL =
  'https://www.taikooplace.com/zh-hk/taikooplaceapp-termsconditions';

export const SWIRE_APP_EN_PACIFIC_PLACE_OFFICE_TERMS_AND_CONDITIONS_URL =
  'https://www.pacificplace.com.hk/en/work/pacificplaceoffices-termsconditions';

export const SWIRE_APP_ZH_HK_PACIFIC_PLACE_OFFICE_TERMS_AND_CONDITIONS_URL =
  'https://www.pacificplace.com.hk/zh-hk/work/pacificplaceoffices-termsconditions';

// swire domains
export const SWIRE_DOMAINS = [
  'app.taikooplace.com',
  'app.pacificplaceoffices.com',
  'd.activate.vts.com', // This is for dev testing
  's.activate.vts.com', // This is for staging testing
];

export enum SWIRE_LANGUAGE_ENUM {
  EN_US = 'en-US',
  ZH_HK = 'zh-HK',
}

export const SWIRE_LANGUAGE_SELECTION = [
  {
    name: 'English',
    value: SWIRE_LANGUAGE_ENUM.EN_US,
  },
  {
    name: '繁體中文',
    value: SWIRE_LANGUAGE_ENUM.ZH_HK,
  },
];
